import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import Button from '../ui/Button';
import OptimizedImage from '../ui/OptimizedImage';
const WelcomeMessage = () => {
  return <section className="py-12 md:py-16 bg-white" data-id="element-355">
      <div className="container mx-auto px-4" data-id="element-356">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-357">
          <div className="order-2 lg:order-1" data-id="element-358">
            <div className="relative" data-id="element-359">
              <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg" alt="Students of Isonyin Grammar School" className="w-full rounded-lg shadow-lg" aspectRatio="4/3" priority data-id="element-360" />
              <div className="absolute -bottom-4 -right-4 bg-yellow-500 text-blue-900 p-4 rounded-lg shadow-lg transform rotate-3 hidden md:block" data-id="element-361">
                <p className="font-bold text-sm" data-id="element-362">Est. March 23, 1956</p>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-363">
            <div className="text-left mb-6" data-id="element-364">
              <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-3" data-id="element-365">
                Welcome to Isonyin Grammar School!
              </h2>
              <div className="w-24 h-1 bg-yellow-500" data-id="element-366"></div>
            </div>
            <div className="space-y-4 text-gray-700 text-sm md:text-base" data-id="element-367">
              <p className="leading-relaxed" data-id="element-368">
                As the principal of Isonyin Grammar School, it is my pleasure to
                extend a warm welcome to you. We are thrilled to have you visit
                and explore our online space.
              </p>
              <p className="leading-relaxed" data-id="element-369">
                Isonyin Grammar School is a distinguished co-educational
                secondary school established on March 23, 1956, and located in
                the heart of Isonyin-Ijebu, Ogun State. As one of the flagship
                schools of the Ogun State Government and the only Model
                Secondary School with boarding facilities in Ijebu Northeast, we
                are proud of our rich heritage, academic excellence, and the
                global impact of our alumni.
              </p>
              <p className="leading-relaxed" data-id="element-370">
                Our school is fully equipped with modern infrastructure,
                including a professional library, science and ICT laboratories,
                and a carpentry workshop in line with the government's TVET
                policy.
              </p>
              <div className="pt-4" data-id="element-371">
                <Button href="/about" variant="secondary" icon={<ArrowRightIcon data-id="element-373" />} iconPosition="right" data-id="element-372">
                  Learn More About Us
                </Button>
              </div>
            </div>
            <div className="mt-6 border-t border-gray-200 pt-6 flex items-center" data-id="element-374">
              <OptimizedImage src="https://cdn.magicpatterns.com/uploads/ny9gkWcQrLZfy1eVnzqurw/WhatsApp_Image_2026-03-10_at_19.19.06_(1).jpg" alt="Mr. Olugbenga Odunaike - Principal" className="w-16 h-16 md:w-20 md:h-20 rounded-full border-4 border-yellow-500 shadow-md mr-4 flex-shrink-0" objectFit="cover" data-id="element-375" />
              <div data-id="element-376">
                <p className="text-blue-900 font-bold mb-1 text-sm md:text-base" data-id="element-377">
                  Isonyin Grammar School… God is our Foundation!
                </p>
                <p className="text-gray-700 text-sm" data-id="element-378">Warm regards,</p>
                <p className="text-gray-900 font-semibold text-sm md:text-base" data-id="element-379">
                  Mr. Olugbenga Odunaike
                </p>
                <p className="text-gray-600 text-xs md:text-sm" data-id="element-380">Principal</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default WelcomeMessage;